export const OTHER_OPTION = 'other';